export function btnmatrix(ctx) {
    return {
        styles: {
            main: { ...ctx.pretty, radius: 5, padding: 0 },
            // item_buttons part — uses btn style. Values re-use ctx.btnStyle's real
            // per-state colors (built in shared.js) — the actual
            // CHECKED/PRESSED/PRESSED+CHECKED/DISABLED/DISABLED+CHECKED colors
            // (lv_theme_hasp.c:375-394).
            item_buttons: {
                bg_color:     ctx.btnBg,
                border_color: ctx.btnBorder,
                border_width: 2,
                text_color:   ctx.TEXT_DEFAULT,
                text_font:    32,
                radius:       5,
                states: {
                    checked:         { bg_color: ctx.btnChk,   border_color: ctx.BTN_BORDER_CHK, text_color: ctx.TEXT_CHK },
                    pressed:         { bg_color: ctx.btnPr,    border_color: ctx.BTN_BORDER_CHK, text_color: ctx.TEXT_PR  },
                    pressedChecked:  { bg_color: ctx.btnChkPr, text_color: ctx.TEXT_CHK },
                    disabled:        { text_color: ctx.TEXT_DIS },
                    disabledChecked: { bg_color: ctx.BTN_DIS,  text_color: ctx.TEXT_DIS },
                },
            },
        },
    };
}
